import React from "react";

interface TeaserAdMarkerProps {
  adIdentifier: boolean;
}

function TeaserAdMarker({ adIdentifier }: TeaserAdMarkerProps) {
  return (
    <>
      {adIdentifier && <div className="teaser-ad-marker">-Anzeige-</div>}
    </>
  );
}

export default TeaserAdMarker;
